module.exports = __webpack_public_path__ + "img/ad4.a7607d11.png";